export const REDIRECT_PATH_AFTER_LOGIN = 'schedulinkRedirectPath';
